export default {"src":"/_next/static/media/RF.a4db86a6.svg","height":18,"width":18};